import { Badge, FlexLayout } from '@deity/falcon-ui';
import { EndpointType } from 'contracts/enums';
import styles from './EndpointBadges.module.css';

const xxs: any = 'xxs';

export const EndpointTypeBadge = ({ schema }: { schema: any }) => {
  if (!schema) {
    return null;
  }

  return (
    <FlexLayout width="full">
      {schema?.type === EndpointType.REST && (
        <Badge py={xxs} fontWeight="bold" className={styles.restStyle}>
          REST
        </Badge>
      )}
    </FlexLayout>
  );
};
